import * as Sentry from "@sentry/react";

function getFirebaseErrorCode(error: unknown): string | undefined {
    if (typeof error === "object" && error !== null && "code" in error) {
        const c = (error as { code?: string }).code;
        if (c != null && c !== "") return String(c);
    }
    return undefined;
}

/** Report to Sentry with arbitrary string tags (e.g. feature area, operation). */
export function captureExceptionWithSentryTags(error: unknown, tags: Record<string, string>): void {
    Sentry.withScope((scope) => {
        for (const [key, value] of Object.entries(tags)) {
            scope.setTag(key, value);
        }
        Sentry.captureException(error);
    });
}

/**
 * Firebase client errors: sets `flow`, and when `code` is present, `firebaseCode` and `step`
 * (`auth` if code starts with `auth/`, otherwise `firestore` for Firestore and other SDK errors).
 */
export function captureFirebaseErrorForSentry(
    error: unknown,
    flow: string,
    extraTags?: Record<string, string>,
): void {
    const tags: Record<string, string> = { flow, ...extraTags };
    const code = getFirebaseErrorCode(error);
    if (code) {
        tags.firebaseCode = code;
        tags.step = code.startsWith("auth/") ? "auth" : "firestore";
    }
    captureExceptionWithSentryTags(error, tags);
}
